import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";
import { useGlobalContext } from "../../GlobalContext";
import BaseComponent, { BaseProps } from "../BaseComponent";

export default function BaseApplicationComponent(props: BaseProps) {
  const { accountInfo } = useGlobalContext();
  const {
    application: { hasAppeal },
    applicationBase,
  } = useApplicationContext();

  return (
    <BaseComponent
      {...props}
      showNoValidateBtn={props.showNoValidateBtn ?? applicationBase.isPresubmission}
      showEdit={
        props.showEdit ??
        (props.disabled && !hasAppeal && (accountInfo.isInternal || (accountInfo.isKindergarten && applicationBase.canKindergartenEdit)))
      }
      submitBtnTitle={(props.showNoValidateBtn ?? applicationBase.isPresubmission) ? "Check this Section for Errors" : props.submitBtnTitle}
    />
  );
}
